<template>
  <div class="newDetailBx">
    <Menu />
    <div class="newsDetail" v-if="content">
      <div class="head">
        <div class="breadNav">
          <router-link target="_self" :to="`/resourceCenter`">资讯</router-link>
          <span class="angle">></span>
          <span>详情</span>
        </div>
        <div class="title">{{ content.article_title }}</div>
        <div class="info">
          <img src="@/assets/menu/logo.svg" class="itemLogo" alt="ToDesk" />
          <p class="itemTime">{{ content.release_time }}</p>
        </div>
        <div class="line"></div>
      </div>
      <div class="cont" v-html="content.info_content"></div>
      <div class="prevNext">
        <router-link
          target="_self"
          v-if="content.prev"
          :to="`/news/${content.prev.id}`"
          class="pnItem active"
        >
          <img
            class="pnIcon pi1"
            src="@/assets/resourceCenter/icon_superior_have.png"
            alt="上一篇"
          />
          <img
            class="pnIcon pi2"
            src="@/assets/resourceCenter/icon_superior_click.png"
            alt="上一篇"
          />
          上一篇：{{ content.prev.article_title }}
        </router-link>
        <p v-else class="pnItem">
          <img
            class="pnIcon pi1"
            src="@/assets/resourceCenter/icon_superior_have.png"
            alt="上一篇"
          />
          上一篇：没有了
        </p>
        <router-link
          target="_self"
          v-if="content.next"
          :to="`/news/${content.next.id}`"
          class="pnItem active"
        >
          <img
            class="pnIcon pi1"
            src="@/assets/resourceCenter/icon_down_have.png"
            alt="下一篇"
          />
          <img
            class="pnIcon pi2"
            src="@/assets/resourceCenter/icon_down_click.png"
            alt="下一篇"
          />
          下一篇：{{ content.next.article_title }}
        </router-link>
        <p v-else class="pnItem">
          <img
            class="pnIcon pi1"
            src="@/assets/resourceCenter/icon_superior_have.png"
            alt="上一篇"
          />
          下一篇：没有了
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      id: "",
      content: null,
    };
  },
  async created() {
    this.id = this.$route.params.id;
    await this.getData();
  },
  methods: {
    async getData() {
      let res = await this.$serve.getNewsDetail({
        id: this.id,
      });
      this.content = res.data;
      this.content.release_time = this.content.release_time
        .split(".")[0]
        .split("T")[0];
    },
  },
};
</script>
<style lang="less" scoped>
.newDetailBx {
  background: #fff;
}
.newsDetail {
  padding: 15px;
  .head {
    .breadNav {
      display: flex;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #0070f9;
      font-size: 16px;
      .angle {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .title {
      font-weight: bold;
      font-size: 24px;
    }
    .info {
      margin-top: 10px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .itemLogo {
        height: 17px;
        width: auto;
      }
      .itemTime {
        margin-left: 30px;
        color: #999999;
        font-size: 16px;
      }
      .itemMarks {
        display: flex;
        .mark {
          margin-left: 25px;
          color: #0070f9;
          padding: 2px 12px;
          border-radius: 12px;
          background-color: rgba(0, 112, 249, 0.05);
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #e9e9e9;
    }
  }
  .prevNext {
    .pnItem {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #666;
      .pnIcon {
        margin-right: 10px;
      }
      .pnIcon.pi2 {
        display: none;
      }
    }
  }
}
.cont {
  padding-top: 20px;
  padding-bottom: 30px;
  /deep/ span,
  /deep/ p,
  /deep/ {
    color: #666666;
  }
  /deep/ img {
    max-width: 100%;
    margin: 0 auto;
    display: inline;
  }
  /deep/ a {
    display: inline;
  }
  /deep/ p {
    min-height: 21px;
    font-size: 18px;
  }
  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,
  /deep/ h6 {
    color: #333333;
    line-height: normal;
    font-weight: normal;
    span {
      color: #333333;
    }
  }
  /deep/ h1 {
    font-size: 32px;
    margin-bottom: 16px;
  }
  /deep/ h2 {
    font-size: 24px;
    margin-bottom: 12px;
  }
  /deep/ h3 {
    font-size: 18px;
    margin-bottom: 9px;
  }
  /deep/ h4 {
    font-size: 16px;
    margin-bottom: 8px;
  }
  /deep/ h5 {
    font-size: 13px;
    margin-bottom: 6px;
  }
  /deep/ h6 {
    font-size: 12px;
    margin-bottom: 5px;
  }
  /deep/ hr {
    margin-top: 24px;
    margin-bottom: 24px;
    border: none;
    border-top: 1px solid #dee0e3;
  }
}
</style>
